module.exports = __webpack_public_path__ + "static/img/badge_empty.0eebd94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/badge_empty.png
// module id = Lh61
// module chunks = 1